import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import {TableComponent} from './table.component';
import {TableModule} from 'src/app/table/table.module';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {IconsModule} from '../../icons/icons.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatMenuModule} from '@angular/material/menu';
import {MatDividerModule} from '@angular/material/divider';
import { ManageColumnsModule } from '../manage-columns/manage-columns.module';
import { SatPopoverModule } from '@ncstate/sat-popover';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { PipesModule } from 'src/app/pipes/pipes.module';
@NgModule({
  declarations: [
    TableComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TableModule,
    PaginatorModule,
    NgxSkeletonLoaderModule,
    IconsModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatDividerModule,
    ManageColumnsModule,
    SatPopoverModule,
    ClipboardModule,
    PipesModule
  ],
  exports: [
    TableComponent
  ]
})
export class CommonTableModule {
}
